// extracted by mini-css-extract-plugin
export default {"root":"arrow-module__root--PYh5K","toRight":"arrow-module__toRight--VC5eS"};